import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, loadUser, forgotPassword } from '../../redux/actions/userAction';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { Container, Form, InputGroup } from 'react-bootstrap';
import SectionHeading from '../common/SectionHeading';
import { AiOutlineMail } from 'react-icons/ai';
import Loader from '../common/Loader';
import MetaData from '../MetaData';

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { error, message, loading } = useSelector((state) => state.forgotPassword);

    const [email, setEmail] = useState('');

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }

        if (message) {
            toast.success(message);
        }
    }, [error, message]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(forgotPassword({ email: email }));
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title='Forgot Password' />
            <div className='loginScreen'>
                <Container>
                    <div className='formContainer'>
                        <div className='formContentSection'>
                            <SectionHeading heading={'Forgot Password'} />
                            <div className='loginRegisterForm'>
                                <form onSubmit={handleSubmit}>
                                    <InputGroup className='mb-3'>
                                        <InputGroup.Text id='basic-addon1'>
                                            <AiOutlineMail />
                                        </InputGroup.Text>
                                        <Form.Control
                                            placeholder='Email'
                                            aria-label='email'
                                            name='email'
                                            type='email'
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </InputGroup>
                                    <input type='submit' value='Send' className='submitBtn' />
                                </form>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default ForgotPassword;
